import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { LogIn } from "lucide-react";
import SocialWidget from "../Widget/SocialWidget";
import Newsletter from "../Widget/Newsletter";
import IconBoxStyle11 from "../IconBox/IconBoxStyle11";
import Spacing from "../Spacing";
import { Button } from "../ui/input/Button";
import {
  Facebook,
  Instagram,
  Phone,
  YouTube,
  Mail,
  LinkedIn,
} from "@mui/icons-material";
import XIcon from "@mui/icons-material/X";
import NavLinkTransition from "./NavLinkTransition";

export default function Header({ logoSrc, variant }) {
  const [isSticky, setIsSticky] = useState(false);
  const [mobileToggle, setMobileToggle] = useState(false);
  const [sideNav, setSideNav] = useState(false);
  const [activeNav, setActiveNav] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const [showPhone, setShowPhone] = useState(false);
  const [showMail, setShowMail] = useState(false);
  const [isScrolled, setIsscrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsscrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
  }, []);

  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;

    // Handle path-based routes
    switch (path) {
      case "/about":
        setActiveNav("about");
        break;
      case "/ourteam":
        setActiveNav("team");
        break;
      case "/gallery":
        setActiveNav("gallery");
        break;
      case "/contact":
        setActiveNav("contact");
        break;
      case "/career":
        setActiveNav("career");
        break;
      case "/Latest-update":
        setActiveNav("latest");
        break;
      case "/doctors":
        setActiveNav("doctors");
        break;
      case "/":
        setActiveNav("home");
        break;
      default:
        setActiveNav("home");
    }
  }, [location.pathname]);

  const navbarRoutes = [
    { to: "/", label: "Home", navKey: "home" },
    { to: "/about", label: "About", navKey: "about" },
    { to: "/ourteam", label: "Our Team", navKey: "team" },
    { to: "/career", label: "Career", navKey: "career" },
    { to: "/Latest-update", label: "Latest Update", navKey: "latest" },
    { to: "/gallery", label: "Gallery", navKey: "gallery" },
    { to: "/doctors", label: "Find Consultant", navKey: "doctors" },
    { to: "/contact", label: "Contact", navKey: "contact" },
  ];

  return (
    <>
      <header
        className={`cs_site_header cs_style1 cs_sticky_header ${
          mobileToggle ? "cs_mobile_toggle_active" : ""
        } ${variant} ${isSticky ? "cs_active_sticky" : ""}`}
      >
        <div className="cs_main_header">
          <div className="container">
            <div className="cs_main_header_in">
              <div className="cs_main_header_left">
                <Link className="cs_site_branding" to="/">
                  <img src={logoSrc} alt="Logo" width={180} />
                </Link>

                <nav className="cs_nav">
                  <ul
                    className={`${
                      mobileToggle ? "cs_nav_list cs_active" : "cs_nav_list"
                    }`}
                  >
                    <Link to="/signup" className="md:hidden mb-12">
                      <Button className="flex justify-center items-center w-[7rem] gap-2 mt-[50px] md:mt-[0]">
                        Login <LogIn size={20} />
                      </Button>
                    </Link>

                    {navbarRoutes.map(({ to, label, navKey }) => (
                      <NavLinkTransition
                        key={navKey}
                        to={to}
                        label={label}
                        navKey={navKey}
                        activeNav={activeNav}
                        setActiveNav={setActiveNav}
                        setMobileToggle={setMobileToggle}
                      />
                    ))}
                  </ul>

                  <span
                    className={
                      mobileToggle
                        ? "cs_menu_toggle cs_teggle_active"
                        : "cs_menu_toggle"
                    }
                    onClick={() => setMobileToggle(!mobileToggle)}
                  >
                    <span></span>
                  </span>
                </nav>
              </div>

              <div className="cs_main_header_right">
                <div className="cs_toolbox flex justify-center items-center">
                  <Link to="/signup" className="hidden md:block">
                    <Button className="flex justify-center items-center w-[7rem] gap-2">
                      Login <LogIn size={20} />
                    </Button>
                  </Link>

                  <button
                    className="cs_toolbox_btn cs_sidebar_toggle_btn"
                    type="button"
                    onClick={() => setSideNav(!sideNav)}
                  >
                    <svg
                      width={35}
                      height={30}
                      viewBox="0 0 35 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.483887 2.46544C0.483887 1.10383 1.14618 0 1.96315 0H33.5208C34.3377 0 35 1.10383 35 2.46544C35 3.82708 34.3377 4.93088 33.5208 4.93088H1.96315C1.14618 4.93088 0.483887 3.82708 0.483887 2.46544Z"
                        fill="currentColor"
                      />
                      <path
                        d="M0.483887 14.6694C0.483887 13.3074 1.14618 12.2039 1.96315 12.2039H33.5208C34.3377 12.2039 35 13.3074 35 14.6694C35 16.0309 34.3377 17.1348 33.5208 17.1348H1.96315C1.14618 17.1348 0.483887 16.0309 0.483887 14.6694Z"
                        fill="currentColor"
                      />
                      <path
                        d="M0.483887 26.6267C0.483887 25.2648 1.14618 24.1613 1.96315 24.1613H33.5208C34.3377 24.1613 35 25.2648 35 26.6267C35 27.9883 34.3377 29.0922 33.5208 29.0922H1.96315C1.14618 29.0922 0.483887 27.9883 0.483887 26.6267Z"
                        fill="currentColor"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`text-center sticky md:top-[68px] top-[40px] p-2 flex flex-row gap-4 
    ${isScrolled ? "bg-white shadow-md" : "bg-transparent"} 
    rounded-xl z-20 
    justify-center 
    mx-auto 
    absolute 
    md:absolute 
    md:mx-0 
    left-0 right-0 w-fit transition-all duration-500`}
        >
          <a
            href="https://www.facebook.com/NHWMOH/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Facebook className="transition-transform duration-300 ease-in-out hover:text-blue-600 cursor-pointer hover:scale-110" />
          </a>

          <a
            href="https://www.instagram.com/nhwmoh2021"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Instagram className="transition-transform duration-300 ease-in-out hover:text-pink-700 cursor-pointer hover:scale-110" />
          </a>

          <a
            href="https://www.linkedin.com/company/nhwm/?viewAsMember=true"
            rel="noopener noreferrer"
            target="_blank"
          >
            <LinkedIn className="transition-transform duration-300 ease-in-out hover:text-blue-800 cursor-pointer hover:scale-110" />
          </a>

          <a
            href="https://x.com/NHWMOH"
            rel="noopener noreferrer"
            target="_blank"
          >
            <XIcon className="transition-transform duration-300 ease-in-out hover:text-blue-400 cursor-pointer hover:scale-110" />
          </a>
          <a
            href="https://www.youtube.com/@nhwmoh"
            target="_blank"
            rel="noopener noreferrer"
          >
            <YouTube className="hover:text-red-500 cursor-pointer hover:scale-110" />
          </a>

          {/* Phone with dropdown */}
          <div className="relative">
            {/* Phone Icon */}
            <div
              onClick={() => setShowPhone((prev) => !prev)}
              className={`cursor-pointer p-1 rounded-full transition-all duration-300
      ${showPhone ? "bg-gray-200 scale-110 text-blue-500" : ""}
    `}
            >
              <Phone className="transition-transform duration-300 ease-in-out hover:text-blue-400 mt-[-5px]" />
            </div>

            {/* Dropdown */}
            {showPhone && (
              <div
                className="
        absolute 
        top-10 
        bg-white 
        border 
        rounded-lg 
        p-2 
        shadow-lg 
        text-sm 
        z-50 
        w-[180px]

        left-1/2 -translate-x-1/2
        md:left-auto md:-translate-x-0 md:right-0
      "
              >
                <div className="flex flex-col gap-1">
                  <a
                    className="text-black p-2 hover:bg-gray-100 rounded"
                    href="tel:+913614516663"
                  >
                    📞 +91 3614516663 (Call)
                  </a>
                  <a
                    className="text-black p-2 hover:bg-gray-100 rounded"
                    href="tel:+919707076232"
                  >
                    📞 +91 9707076232 ( WA & Call)
                  </a>
                  <a
                    className="text-black p-2 hover:bg-gray-100 rounded"
                    href="tel:+919707998887"
                  >
                    📞 +91 9707998887 ( WA & Call)
                  </a>
                </div>
              </div>
            )}
          </div>

          {/* YouTube */}

          {/* Mail with dropdown */}
          <div
            className="relative"
            onMouseEnter={() => setShowMail(true)}
            onMouseLeave={() => setShowMail(false)}
            onTouchStart={() => setShowMail(false)}
            onTouchEnd={() => setShowMail(false)}
          >
            <a
              href="mailto:nhwm.info@gmail.com"
              rel="noopener noreferrer"
              target="_blank"
            >
              <Mail className="transition-transform duration-300 ease-in-out hover:text-red-500 cursor-pointer hover:scale-110" />
            </a>
            {showMail && (
              <div className="hidden md:block absolute top-10  bg-white border rounded-lg p-2 shadow-lg text-sm z-50 w-[200px]">
                <div className="flex justify-between items-center">
                  <span className="text-black">✉️ nhwm.info@gmail.com</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </header>

      {/* SideNav */}
      <div className={`cs_sidenav ${sideNav ? "active" : ""}`}>
        <div className="cs_sidenav_overlay" onClick={() => setSideNav(false)} />
        <div className="cs_sidenav_in">
          <button
            className="cs_close"
            type="button"
            onClick={() => setSideNav(false)}
          >
            <img src="/images/icons/close.svg" alt="Close" />
          </button>
          <div className="cs_logo_box">
            <img
              style={{ height: 30 }}
              src="/images/nhwm_logo.png"
              alt="Logo"
            />
            <div className="cs_height_15" />
            <h3 className="cs_fs_24 cs_semibold mb-0">
              Your Partner in Healthcare and Wellness
            </h3>
          </div>
          <Spacing md="35" lg="35" xl="35" />
          <hr />
          <Spacing md="35" lg="50" xl="35" />
          <IconBoxStyle11
            title="Phone"
            subTitle="+91 3614516663 (Call), +91 9707076232, +91 9707998887 (WA and Call)"
            href="tel:+91 3614516663"
            iconSrc="/images/contact/icon_1.svg"
          />
          <Spacing md="30" lg="30" xl="30" />
          <IconBoxStyle11
            title="Email"
            subTitle="info@nhwm.in"
            href="mailto:info@nhwm.in"
            iconSrc="/images/contact/icon_2.svg"
          />
          <Spacing md="30" lg="30" xl="30" />
          <IconBoxStyle11
            title="Location"
            subTitle="Karbi Namghar Path, Borbari, Guwahati"
            href="https://www.google.com/maps/place/National+Healthcare+%26+Wellness+Mission/@26.1502318,91.8073213,17z/data=!3m1!4b1!4m6!3m5!1s0x375a59aa64f75da1:0xa9fa61749a2b8496!8m2!3d26.150227!4d91.8098962!16s%2Fg%2F11ny0tcys6?entry=ttu&g_ep=EgoyMDI1MDcxNS4xIKXMDSoASAFQAw%3D%3D"
            iconSrc="/images/contact/icon_3.svg"
          />
          <Spacing md="60" lg="60" xl="60" />
          <Newsletter />
          <Spacing md="70" lg="50" xl="50" />
          <hr />
          <Spacing md="70" lg="50" xl="50" />
          <SocialWidget />
        </div>
      </div>
    </>
  );
}
